<div class="flex-col content-wrapper">
    <div class="title-message">{{ title_message() }}</div>
    <h2>{{ message() }}</h2>
</div>
